import {Vue} from "vue-class-component";
import {useStore} from "@/store";
import {Game} from "@/data/Game";
import {Environment} from "@/data/Environment";
import {TestingParameters} from "@/data/TestingParameters";
import {Language} from "@/data/Language";
import { Integration } from "@/data/Integration";

export default class AbstractVue extends Vue {
    store = useStore();

    get parameters(): TestingParameters {
        return this.store.state.parameters;
    }

    get environments(): Environment[] {
        return this.store.state.environments;
    }

    get integrations(): Integration[] {
        return this.store.state.integrations;
    }

    get languages(): Language[] {
        return this.store.state.languages;
    }

    get currencies(): string[] {
        return this.store.state.currencies;
    }

    get playModes(): string[] {
        return this.store.state.playModes;
    }

    get isLocal(): boolean {
        return this.store.state.local;
    }

    get isMock(): boolean {
        return this.store.state.mock;
    }

    get isPrototype(): boolean {
        return this.store.state.prototype;
    }

    get games(): Game[] {
        return this.store.state.games;
    }
}
